const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_ProjectList":
      return { ...state, List: payload };
    case "SAVE_ProjectDetail":
      return { ...state, Detail: payload };
    case "SAVE_ProjectMembers":
      return { ...state, Members: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
